import React, { Component } from 'react'
import PropTypes from 'prop-types'
import update from 'immutability-helper'

import classnames from 'classnames'

import Rnd from 'react-rnd'
import { RIEInput } from 'riek'

import { calculateColorNumber } from '../../functions'

import Rotate from './rotate'
import Resize from './resize'

class StageplanItem extends Component {
  constructor(props) {
    super(props)

    this.state = {
      item: undefined,
      showControlHandles: false,
      isDragging: false,
      isRotating: false,
      isResizing: false
    }

    this.dragItem = React.createRef()
    this.input = React.createRef()
  }

  componentWillMount() {
    const { canvas } = this.props
    let { item } = this.props

    item = this.convertPercentageToPixels(item, canvas)
    this.setState({item})
  }

  componentWillReceiveProps(nextProps) {
    const { item, canvas } = nextProps

    if (item !== this.props.item || canvas !== this.props.canvas) {
      const convertedItem = this.convertPercentageToPixels(item, canvas)
      this.setState({item: convertedItem})
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    const { item, itemIsFocused, canvas } = nextProps

    if (itemIsFocused !== this.props.itemIsFocused) return true
    if (item !== this.props.item) return true
    if (canvas !== this.props.canvas) return true
    if (nextState !== this.state) return true
    return false
  }

  componentWillUpdate(nextProps, nextState) {
    const { isDragging } = nextState

    if (isDragging !== this.state.isDragging) this.props.setDragState(isDragging)
  }

  componentDidUpdate(prevProps, prevState) {
    const input = this.input.current

    if (input && !input.props.value) input.startEditing()
  }

  convertPercentageToPixels(item, canvas) {
    const pxWidth = item.width*canvas.ratio
    const pxHeight = item.height*canvas.ratio

    item = update(item, {
      pxWidth: {$set: pxWidth},
      pxHeight: {$set: pxHeight},
      x: {$set: canvas.width*(item.left/100)-(pxWidth/2)},
      y: {$set: canvas.height*(item.top/100)-(pxHeight/2)}
    })

    return item
  }

  convertPixelsToPercentage(item, canvas) {
    item = update(item, {
      width: {$set: item.pxWidth/canvas.ratio},
      height: {$set: item.pxHeight/canvas.ratio},
      top: {$set: ((item.y+(item.pxHeight/2))/canvas.height)*100},
      left: {$set: ((item.x+(item.pxWidth/2))/canvas.width)*100}
    })

    return item
  }

  createStageplanItem(item) {
    const { canvas } = this.props

    item = this.convertPixelsToPercentage(item, canvas)
    this.props.createRiderStageplanItem(item)
  }

  editStageplanItem(item) {
    const { canvas } = this.props

    item = this.convertPixelsToPercentage(item, canvas)
    this.props.editRiderStageplanItem(item)
  }

  onDragStop = (e, d, item) => {
    item = update(item, {
      x: {$set: d.x},
      y: {$set: d.y}
    })

    this.setState({item}, () => {
      if (item.id) this.editStageplanItem(item)
    })
  }

  renderStageplanItem() {
    const { itemIsFocused, view, fontSize } = this.props
    const { item, showControlHandles, isDragging, isRotating, isResizing } = this.state
    const { pxWidth, pxHeight, x, y } = item

    const colorNumber = calculateColorNumber(item.color, 5)
    const shape = item.shape || (item.params && item.params.shape)

    const className = classnames({
      'stageplan-item': true,
      [`stageplan-item--color-${colorNumber}`]: item.color !== null,
      'stageplan-item--focus': itemIsFocused === true,
      'stageplan-item--dragging': isDragging || isRotating || isResizing,
      'stageplan-item--hidden': item.hidden,
      [`stageplan-item--shape-${shape}`]: shape
    })

    const rotateClassName = classnames({
      'resize': true,
      'rotate--visible': (showControlHandles && !isRotating && !isResizing) || isRotating
    })

    const resizeClassName = classnames({
      'resize': true,
      'resize--visible': (showControlHandles && !isRotating && !isResizing) || isResizing
    })

    return (
      <Rnd
        size={{width: pxWidth, height: pxHeight}}
        position={{x, y}}
        enableResizing={false}
        disableDragging={!view.editable}
        bounds={'.stageplan-droppable-area'}
        cancel={'.rotate-handle, .resize-handle'}
        dragHandleClassName={'.stageplan-item'}
        onDragStart={(e) => view.editable ? this.setState({isDragging: true}) : null}
        onDragStop={(e, d) => {
          if (view.editable) {
            if (e.target.className === 'stageplan-remove-item-overlay') {
              this.setState({
                isDragging: false,
                item: update(item, {
                  hidden: {$set: true} // https://github.com/bokuweb/react-rnd/issues/216
                })
              }, () => this.props.deleteRiderStageplanItem(item.id, item.index))
            } else {
              this.setState({isDragging: false}, () => this.onDragStop(e, d, item))
            }
          }
        }} >

        <div className={className} style={{transform: `rotateZ(${item.rotation.degrees}deg)`}}
          onMouseEnter={() => view.editable ? this.setState({showControlHandles: true}) : null}
          onMouseLeave={() => view.editable ? this.setState({showControlHandles: false}) : null}>
          <div className="title" style={{fontSize}}>
            {
              item.channel
              ? <span className="channel" style={{fontSize: fontSize*1.1}}>{item.channel}</span>
              : null
            }

            {item.title}
          </div>

          {
            view.editable
            ? <Rotate className={rotateClassName}
                onRotateStart={() => this.setState({isRotating: true})}
                onRotateEnd={() => this.setState({isRotating: false})}
                onRotate={(rotation) => {
                  this.setState({
                    item: update(item, {
                      $merge: {rotation}
                    })
                  })
                }}
                editRiderStageplanItem={() => this.editStageplanItem(item)} />
            : null
          }

          {
            view.editable
            ? <Resize className={resizeClassName}
                attributes={{
                  x: item.x,
                  y: item.y,
                  width: item.pxWidth,
                  height: item.pxHeight,
                  radians: item.rotation.radians
                }}
                onResizeStart={() => this.setState({isResizing: true})}
                onResizeEnd={() => this.setState({isResizing: false})}
                onResize={(attributes) => {
                  this.setState({
                    item: update(item, {
                      $merge: attributes
                    })
                  })
                }}
                editRiderStageplanItem={() => this.editStageplanItem(item)} />
            : null
          }
        </div>
      </Rnd>
    )
  }

  renderEmptyStageplanItem() {
    const { view, canvas, fontSize } = this.props
    const { item, isDragging } = this.state
    const { pxWidth, pxHeight, x, y } = item

    const shape = item.shape || (item.params && item.params.shape)

    const className = classnames({
      'stageplan-item': true,
      'stageplan-item--focus': !item.title,
      'stageplan-item--hidden': item.hidden,
      'stageplan-item--dragging': isDragging,
      [`stageplan-item--shape-${shape}`]: shape
    })

    if (view.editable !== true) return null

    return (
      <Rnd ref={this.dragItem}
        size={{width: pxWidth, height: pxHeight}}
        position={{x, y}}
        enableResizing={false}
        bounds={'.stageplan-droppable-area'}
        cancel={'.rotate-handle, .resize-handle'}
        dragHandleClassName={'.stageplan-item'}
        onDragStart={(e) => this.setState({isDragging: true})}
        onDragStop={(e, d) => {
          if (e.target.className === 'stageplan-remove-item-overlay') {
            this.setState({
              isDragging: false,
              item: update(item, {
                hidden: {$set: true} // https://github.com/bokuweb/react-rnd/issues/216
              })
            }, () => setTimeout(() => this.props.removeRiderStageplanItem(), 1)) // https://github.com/bokuweb/react-rnd/issues/216
          } else {
            this.setState({isDragging: false}, () => this.onDragStop(e, d, item))
          }
        }} >

        <div className={className} style={{transform: `rotateZ(${item.rotation.degrees}deg)`}}>
          {
            item.title
            ? <div className="title" style={{fontSize}}>
                {
                  item.channel
                  ? <span className="channel" style={{fontSize: fontSize*1.1}}>{item.channel}</span>
                  : null
                }

                {item.title}
              </div>
            : <RIEInput ref={this.input}
                value={item.title || ''}
                propName="title"
                className="riek title"
                defaultProps={{style: {fontSize}}}
                editProps={{style: {fontSize}}}
                change={({title}) => this.createStageplanItem({...item, title})} />
          }
        </div>
      </Rnd>
    )
  }

  render() {
    const { item } = this.props

    return item.id !== null
    ? this.renderStageplanItem()
    : this.renderEmptyStageplanItem()
  }
}

StageplanItem.propTypes = {
  view: PropTypes.object,
  item: PropTypes.object,
  itemIsFocused: PropTypes.bool,
  canvas: PropTypes.object,
  fontSize: PropTypes.number,
  setDragState: PropTypes.func,
  removeRiderStageplanItem: PropTypes.func,
  createRiderStageplanItem: PropTypes.func,
  editRiderStageplanItem: PropTypes.func,
  deleteRiderStageplanItem: PropTypes.func
}

StageplanItem.defaultProps = {
  view: {},
  item: {},
  itemIsFocused: false,
  canvas: {
    ratio: 1,
    width: undefined,
    height: undefined
  },
  fontSize: 12,
  setDragState: function() {},
  removeRiderStageplanItem: function() {},
  createRiderStageplanItem: function() {},
  editRiderStageplanItem: function() {},
  deleteRiderStageplanItem: function() {}
}

export default StageplanItem



// WEBPACK FOOTER //
// ./src/components/rider/rider-stageplans/stageplan-item.js